"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDareAssignee = void 0;
const useUser_1 = require("root/src/client/logic/userData/hooks/useUser");
const platforms_1 = require("root/src/shared/@types/platforms");
const useBestPlatform_1 = require("root/src/client/logic/dropEvent/hooks/useBestPlatform");
function useDareAssignee({ dare }) {
    const { tokens } = (0, useUser_1.useUserCreatorData)();
    const bestPlatformToken = (0, useBestPlatform_1.useBestAvailablePlatformToken)();
    if (dare.platform === platforms_1.DarePlatform.Any && bestPlatformToken) {
        return { id: bestPlatformToken.platformId, platform: bestPlatformToken.platform };
    }
    const matchingPlatform = tokens === null || tokens === void 0 ? void 0 : tokens.find(token => token.platform === dare.platform);
    if (!matchingPlatform) {
        return null;
    }
    return { id: matchingPlatform.platformId, platform: matchingPlatform.platform };
}
exports.useDareAssignee = useDareAssignee;
